/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-09-14 09:53:09
 * @LastEditors: Pension 744056574@qq.com
 * @LastEditTime: 2022-09-23 14:50:45
 * @FilePath: /njyx-frontend-pc/packages/share/components/yFetch/Fetch.tsx
 * @Description:获取数据组件
 *
 */
import type { PropType } from "vue";
import { ref, defineComponent } from "vue";
import useRequest from "../../use/useRequest";
import * as dictionary from "../../utils/dictionary";
export default defineComponent({
  name: "Yfetch",
  props: {
    api: {
      type: String as PropType<string>,
      default: "",
    },
    para: {
      type: Object as PropType<any>,
    },
    hasPager: {
      type: Boolean as PropType<boolean>,
      default: false,
    }, //是否有分页,默认有
    tip: {
      type: Boolean as PropType<boolean>,
      default: false,
    }, //是否有提示，默认没有
    maxPageSize: {
      type: Boolean as PropType<boolean>,
      default: false,
    }, //分页size 10000，当列表使用
    manual: {
      type: Boolean as PropType<boolean>,
      default: false,
    }, //组件创建时，不主动调取数据(false)，需要手动调取
    autoGetDataWhenParaChange: {
      type: Boolean as PropType<boolean>,
      default: false,
    }, //数据变化的时候，是否自动请求数据，默认不自动请求
    preprocess: Function, //请求过来数据之后，对数据进行预处理,，并返回需要的数据
    afterProcess: Function, //请求过来数据之后，并返回需要的数据
    finalProcess: Function, //最终都会走的
    type: String, //默认类型
    //改变此参数之后，自动请求数据,设置此参数的目的在于避免获取组件的引用
    refresh: [Number, String],
  },
  setup(props, { slots, attrs }) {
    const {
      api,
      para,
      hasPager,
      tip,
      manual,
      refresh,
      maxPageSize,
      type,
      autoGetDataWhenParaChange,
      preprocess,
      afterProcess,
      finalProcess,
    } = props;
    if (!api) {
      return;
    }
    const {
      isLoading,
      pager,
      total,
      data,
      changePageIndex,
      changePageSize,
      getData,
    } = useRequest({
      api,
      para,
      manual,
      hasPager,
      tip,
      maxPageSize,
      type,
      autoGetDataWhenParaChange,
      preProcess: preprocess as any,
      afterProcess: afterProcess as any,
      finalProcess: finalProcess as any,
    });

    // function getData(api: string, opts?: Record<string, any>): void {
    //   try {
    //     getRequestData(api, opts)
    //   } catch (err) {
    //     console.log("后台出错了", err)
    //   } finally {
    //   }
    // }
    return () => {
      return slots.default?.({
        isLoading: isLoading.value,
        dictionary,
        pager,
        total: total.value,
        data: data.value,
        getData,
        setLoading: (v: boolean) => {
          isLoading.value = v;
        },
        //行为-页码改变
        changePageIndex: changePageIndex,
        //行为-每页数量改变
        changePageSize: changePageSize,
      });
    };
  },
});
